export default __webpack_public_path__ + "static/flyer-meg-7918f06396ee3e6f66d856af7294037a.jpg";